import React from 'react'
import IntlMessages from 'util/IntlMessages'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

const UserInfo = ({profile}) => {
  const {firstName, lastName, type} = profile
  return <div>
    <div className="user-profile">
      <i className="zmdi zmdi-account zmdi-hc-lg text-secondary"/>
      <div className="user-detail ml-2">
        <h4 className="user-name mb-0">{`${firstName} ${lastName}`}</h4>
      </div>
    </div>
    <Link className="dropdown-item text-muted" to={`/${type}/profile`}>
      <i className="zmdi zmdi-face zmdi-hc-fw mr-1"/>
      <IntlMessages id="pages.customer.profile"/>
    </Link>
    <Link className='dropdown-item text-muted' to={'/signout'}>
      <i className='zmdi zmdi-sign-in zmdi-hc-fw mr-1'/>
      <IntlMessages id='popup.logout'/>
    </Link>
  </div>
}

export default UserInfo





// WEBPACK FOOTER //
// ./components/UserInfo/index.js